import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

const AuthRoutes = () => {
  const navigate = useNavigate();
  const userLoggedIn = sessionStorage.getItem("userLoggedIn");
  const userRole = sessionStorage.getItem("userRole");

  useEffect(() => {
    if (userLoggedIn) {
      if (userRole === "2" || userRole === "3") {
        console.log("entra", userRole)
        navigate("/homeAlumno");
      }
      else if (userRole === "1") {
        navigate("/homeAdmin");
      }
    }
  }, [userLoggedIn, userRole, navigate]);

  return <Outlet />;
};

export default AuthRoutes;
